<div class="sidebar" id="left-sidebar">
  @if (!isLeftSidebarHidden()) {
    <vectronic-card
      title="{{ title() }}"
      [displayClose]="true"
      (closed)="toggleLeftSidebarVisibility()"
      [closeIcon]="'chevron_left'"
    >
      <ng-container body>
        <ng-content></ng-content>
      </ng-container>
      <ng-template #cardButtons>
        <ng-template [ngTemplateOutlet]="headerButtons"></ng-template>
      </ng-template>
    </vectronic-card>
  }
  @if (isLeftSidebarHidden()) {
    <button
      mat-button
      [ngClass]="router.url === '/map' || router.url === '/commands' ? 'bg-white' : 'bg-gray'"
      class="toggle-sidebar-button p-0"
      (click)="toggleLeftSidebarVisibility()"
    >
      <mat-icon class="mr-0">{{ isLeftSidebarHidden ? 'arrow_forward' : 'arrow_back' }}</mat-icon>
    </button>
  }
</div>
